var exports = {
  "ik": "authorAvatarImage__5zYgDs",
  "CF": "AuthorAvatarContainer__vnSFNN",
  "mw": "authorHoverableLink__GBl1Aq",
};

module.exports = exports;
